import React from "react";
import LegalLayout from "./LegalLayout";

const TermsOfUse = () => {
  return (
    <LegalLayout title="Terms of Use" lastUpdated="March 22, 2026">
      <section>
        <h2 className="text-2xl font-bold text-white mb-4">1. Agreement to Terms</h2>
        <p>
          By accessing or using Braccet, you agree to be bound by these Terms of Use and all terms incorporated by reference. If you do not agree to all of these terms, do not use our services.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-white mb-4">2. Changes to Terms</h2>
        <p>
          We reserve the right to change or modify these Terms at any time and in our sole discretion. If we make changes to these Terms, we will provide notice of such changes, such as by sending an email notification, providing notice through the Services, or updating the "Last Updated" date at the top of these Terms.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-white mb-4">3. User Accounts</h2>
        <p>
          To access certain features of our Services, you may be required to register for an account. By creating an account, you agree to: (a) provide accurate, current and complete account information; (b) maintain the security of your password; and (c) accept all risks of unauthorized access to your account.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-white mb-4">4. Prohibited Conduct</h2>
        <p>
          You agree that you will not violate any law, contract, intellectual property or other third-party right or commit a tort, and that you are solely responsible for your conduct while using our Services.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-white mb-4">5. Intellectual Property</h2>
        <p>
          Unless otherwise indicated, the Services and all content and other materials on the Services, including, without limitation, the Braccet logo and all designs, text, graphics, pictures, information, data, software, sound files, other files and the selection and arrangement thereof are the proprietary property of Braccet.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-white mb-4">6. Limitation of Liability</h2>
        <p>
          In no event shall Braccet, its directors, members, employees or agents be liable for any direct, special, indirect or consequential damages, or any other damages of any kind.
        </p>
      </section>
    </LegalLayout>
  );
};

export default TermsOfUse;
